const IPV4 = /^\d{1,3}(?:\.\d{1,3}){3}$/;

export function isIpv4(value: string): boolean {
  return IPV4.test(value.trim());
}

/**
 * Matches `ip` only as a whole address: `10.228.175.25` is found in
 * `Neighbor=10.228.175.25 ` but not in `10.228.175.254` nor in `110.228.175.25`.
 * A plain substring search cannot tell them apart, and for a peer's address that
 * is the difference between its lines and its neighbour's. A full stop right
 * after the address (end of a sentence) still counts as the end of the token.
 * `ip` must be an IPv4 (`isIpv4`); the dots are escaped, nothing else is.
 */
export function ipv4TokenRegExp(ip: string, flags = ""): RegExp {
  const escaped = ip.replace(/\./g, "\\.");
  return new RegExp(`(?<!\\d)(?<!\\d\\.)${escaped}(?!\\d)(?!\\.\\d)`, flags);
}
